// extracted by mini-css-extract-plugin
export var askAiIcon = "_op-9";
export var container = "_op-0";
export var groupSeparator = "_op-a";
export var highlight = "_op-4";
export var resultIcon = "_op-5";
export var resultItem = "_op-7";
export var resultSubtitle = "_op-3";
export var resultTitle = "_op-2";
export var resultsList = "_op-1";
export var searchGroup = "_op-6";
export var selected = "_op-8";